import React from 'react';
import { ShieldCheck, BrainCircuit, BookOpen } from 'lucide-react';
export function MechanismSection() {
  const mechanisms = [{
    icon: <ShieldCheck className="h-8 w-8 text-[#C4704B]" data-id="element-84" />,
    title: 'Corte de Culpa en 3 Capas',
    desc: 'Hecho: lo que pasó (sin interpretación). Historia: lo que tu mente concluye (“no valgo”, “yo lo causé”). Castigo: cómo te estás pagando esa historia (rogar, callarte, ceder, desaparecerte).',
    quote: '“Puedo sentir culpa sin obedecerla.”'
  }, {
    icon: <BrainCircuit className="h-8 w-8 text-[#C4704B]" data-id="element-85" />,
    title: 'Mapa DARVO (para detectar el volteo)',
    desc: 'Reconoces cuándo te están haciendo: negar, atacar, hacerse víctima. Y aprendes respuestas de una sola línea para no entrar a la trampa.'
  }, {
    icon: <BookOpen className="h-8 w-8 text-[#C4704B]" data-id="element-86" />,
    title: 'Registro de Realidad (para volver a confiar en ti)',
    desc: 'Porque no puedes reconstruirte si dependes de su versión para sentirte cuerda.'
  }];
  return <section className="bg-[#FFFBF5] px-6 py-16 md:py-24" data-id="element-87">
      <div className="mx-auto max-w-4xl" data-id="element-88">
        <h2 className="mb-12 text-center text-3xl font-bold text-[#2D2420] md:text-4xl" data-id="element-89">
          El mecanismo único{' '}
          <span className="block text-lg font-normal text-[#8B7D75]" data-id="element-90">
            (lo que hace que esto funcione)
          </span>
        </h2>

        <div className="mb-12 text-center text-lg text-[#2D2420]" data-id="element-91">
          <p className="mb-4" data-id="element-92">
            La mayoría de la gente intenta sanar “pensando positivo”.
          </p>
          <p className="font-medium text-[#C4704B]" data-id="element-93">Tú no necesitas eso.</p>
          <p data-id="element-94">Tú necesitas cortar la culpa en el lugar exacto donde nace.</p>
        </div>

        <div className="grid gap-8 md:grid-cols-3" data-id="element-95">
          {mechanisms.map((mech, i) => <div key={i} className="flex flex-col items-center rounded-xl bg-white p-6 text-center shadow-sm ring-1 ring-[#E8DDD4] transition-transform hover:-translate-y-1 hover:shadow-md" data-id="element-96">
              <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-[#FFF3E8]" data-id="element-97">
                {mech.icon}
              </div>
              <h3 className="mb-3 font-serif text-xl font-bold text-[#2D2420]" data-id="element-98">
                {mech.title}
              </h3>
              <p className="mb-4 text-sm leading-relaxed text-[#8B7D75]" data-id="element-99">
                {mech.desc}
              </p>
              {mech.quote && <blockquote className="mt-auto border-t border-[#E8DDD4] pt-4 text-sm italic text-[#C4704B]" data-id="element-100">
                  {mech.quote}
                </blockquote>}
            </div>)}
        </div>
      </div>
    </section>;
}